import { render, staticRenderFns } from "./alarmInfo.vue?vue&type=template&id=2cfaa6bc&scoped=true&"
import script from "./alarmInfo.vue?vue&type=script&lang=js&"
export * from "./alarmInfo.vue?vue&type=script&lang=js&"
import style0 from "./alarmInfo.vue?vue&type=style&index=0&id=2cfaa6bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfaa6bc",
  null
  
)

export default component.exports